import React from 'react'

import axios from 'axios'
import { Messages } from 'primereact/messages';


export class Avisos extends React.Component {

    constructor() {
        super();
        this.state={};
    }

    componentDidMount() {
        this.obtenerAvisosTemporales();
    }

    obtenerAvisosTemporales() {


        let url = 'https://www.facturacionquadrum.com.mx/Notificaciones/notificacion/consultarNotificacionQuadrumApps.json'
        let datos = { "key": "capufe", "value": 1 };

        axios.post(url, datos).then((response) => {
            let avisosExternos = [];
            avisosExternos = response.data;
            avisosExternos.forEach(aviso => {
                this.messages.show({sticky: true, severity: 'success', summary: 'Aviso: ', detail: aviso.mensaje, closable:false });
            })
        }).catch((error) => { });

    }

    componentWillUnmount(){

    }

    render() {
        return (
            <div className="p-fluid" >
                <div className="p-grid">
                    <div className="p-col-12">
                        {/* <div className="p-messages p-component p-messages-success" style={{ margin: '0 0 1em 0', display: 'block' }}>
                            <div className="p-messages-wrapper">
                                <ul>
                                    <li>
                                        <span className="p-messages-detail">
                                            <h3> Aviso:  </h3>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div> */}
                    </div>

                    <div className="p-col-12">
                        <Messages ref={(el) => this.messages = el} />
                    </div>

                </div>
            </div>

        );
    }

}